import ACTION_NAMES from 'actions/ACTION_NAMES';
import { generateUpdateActionCreator } from 'actions/crudActionCreators';
import routes from 'actions/routes';

export default {
    update: generateUpdateActionCreator(routes.API_DATA_RECORD, ACTION_NAMES.DATA_RECORD)
}
